import {
	SET_CONTENT_TYPES,
	SET_CONTENT_TYPE,
	CLEAR_CONTENT_TYPES,
	CLEAR_CONTENT_TYPE,
	ADD_CONTENT_TYPE,
	UPDATE_CONTENT_TYPE,
	REMOVE_CONTENT_TYPE,
} from './actionTypes';

export const contentType = (state = {}, action) => {
	switch (action.type) {
		case SET_CONTENT_TYPE:
			return action.payload;
		case UPDATE_CONTENT_TYPE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CONTENT_TYPE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CONTENT_TYPES:
			return action.payload;
		case ADD_CONTENT_TYPE:
			return [...state, action.payload];
		case UPDATE_CONTENT_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CONTENT_TYPE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CONTENT_TYPES:
			return [];
		default:
			return state;
	}
};
